import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a94ae696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container font-weight-light mt-3" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = { class: "fw-bold mb-2 display-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, " Resume Example", -1))
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Genuine", -1))
const _hoisted_7 = { class: "callout bg-primary-subtle d-flex align-items-center m-1 text-black-30" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-square-fill fs-3 me-3" }, null, -1))
const _hoisted_9 = { class: "fw-light" }
const _hoisted_10 = { class: "p-body row w-100" }
const _hoisted_11 = { class: "col-md-6 col-12" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "col-md-6 col-12 m-auto border-start" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h4 mb-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Why This Resume Works")
  ])
], -1))
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<h3 class=\"h4 mb-2\" data-v-a94ae696><b data-v-a94ae696><i data-v-a94ae696>Our Top Tips For A <u data-v-a94ae696>High-Impact</u> Resume</i></b></h3><h3 class=\"h5 mb-2 ppt-2\" data-v-a94ae696>🎯 Tailor Your Resume to the Job</h3><p data-v-a94ae696> Customize your resume for each application. Highlight experiences and skills that align closely with the job description. </p><h3 class=\"h5 mb-2\" data-v-a94ae696>👁️ Use a Clear and Professional Format</h3><p data-v-a94ae696> Keep your resume clean and easy to read. Use a professional font, consistent formatting, and clear section headings. </p><h3 class=\"h5 mb-2\" data-v-a94ae696>📊 Quantify Achievements</h3><p data-v-a94ae696> Where possible, add numbers to your achievements to show impact, such as &quot;increased sales by 20%&quot; or &quot;reduced processing time by 30%&quot;. </p><h3 class=\"h5 mb-2\" data-v-a94ae696>🔑 Include Keywords From the Job Description</h3><p data-v-a94ae696> Integrate keywords from the job description into your resume. This helps pass applicant tracking systems (ATS) and shows you&#39;re a fit. </p>", 9)
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2" }, "🛠 Highlight Relevant Skills", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Focus on the skills most relevant to the job. Include both hard skills (like software proficiency) and soft skills (like communication). ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2" }, "📝 Keep It Concise", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Limit your resume to 1-2 pages. Be concise and only include information that adds value to your application. ", -1))
const _hoisted_30 = { class: "p-3 rounded bg-success-subtle align-items-center m-1 text-black-30" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search fs-3 mx-3" }, null, -1))
const _hoisted_33 = { class: "fw-light p-3" }
const _hoisted_34 = { class: "d-flex justify-content-center row" }
const _hoisted_35 = { class: "text-success-emphasis" }
const _hoisted_36 = { class: "m-1 rounded bg-body-tertiary" }
const _hoisted_37 = { class: "m-3 text-body p-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 text-body" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("Create Your Resume in "),
    /*#__PURE__*/_createElementVNode("u", null, [
      /*#__PURE__*/_createElementVNode("i", null, "Seconds")
    ]),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("u", null, [
      /*#__PURE__*/_createElementVNode("i", null, "for Free")
    ]),
    /*#__PURE__*/_createTextVNode(" with Job"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Buddy")
  ]),
  /*#__PURE__*/_createTextVNode(" 💡 ")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This resume was built with JobBuddy's AI resume generator. Our resume AI will analyze your target job for keywords, identify relevant experience from your existing resume and reformat it all for you into a beautiful new, tailored resume which you can download as Word or PDF. Join thousands of happy users and create your resume for free in seconds. ", -1))
const _hoisted_40 = { class: "row mt-5 w-100" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-lg w-100" }, "Create Resume", -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "row m-1 text-body p-3 bg-body-tertiary rounded" }
const _hoisted_44 = { class: "col-12 col-sm-6 order-1 order-sm-1" }
const _hoisted_45 = { class: "h5 mb-2 mt-5 text-body" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "genuine", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Optimized for Applicant Tracking Systems", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Professionally Crafted Design", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Demonstrated Effectiveness", -1))
const _hoisted_54 = { class: "col-12 col-sm-6 order-2 order-sm-2 d-flex justify-content-center align-items-center p-2" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "col-12 col-sm-6 order-3 order-sm-3 d-flex justify-content-center align-items-center" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-primary btn-lg w-100" }, "View This Cover Letter", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 mt-5" }, "More Resume Examples", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Browse more cover letter examples for different roles and industries. Each cover letter example is based on a real cover letter that got a candidate hired. ", -1))
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = { class: "overflow-x-auto w-100 d-flex scroll-container" }
const _hoisted_63 = {
  class: "card border-0 m-2",
  style: {"width":"18rem"}
}
const _hoisted_64 = ["src", "alt"]
const _hoisted_65 = { class: "card-body" }
const _hoisted_66 = { class: "card-title text-secondary" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("b", null, "See All Resumes")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Browse our full resume example collection, with a variety of resumes for different roles and industries. ", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-primary btn-lg w-100" }, "View All Resumes", -1))

import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { ResumeExample, resumeExamples } from "./blogs/ResumeExamples";
import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeDetail',
  setup(__props) {

const route = useRoute();
const resumeExample = ref<ResumeExample | undefined>();
// Fetch initial cover letter example based on the initial route.
onMounted(() => {
  loadresumeExample();
});

// Watch for route changes to update the cover letter example.
watch(
  () => route.params.role,
  (newRole) => {
    loadresumeExample();
  }
);

watch(
  () => resumeExample.value, // watching the resumeExample object for changes
  (newVal, oldVal) => {
    if (newVal) {
      // Ensuring that newVal is defined before updating head
      useHead({
        title: `Example of a Successful ${newVal.Role} Resume`, // Dynamic title based on the role
        meta: [
          {
            name: "description",
            content: `See the example ${newVal.Role.toLowerCase()} resume that got somebody hired in their ${newVal.Role.toLowerCase()} role. Explore our collection of successful resumes made with JobBuddy.`, // Dynamic description based on the role
          },
          {
            name: "keywords",
            content: `${
              newVal.Role
            } resume, successful ${newVal.Role.toLowerCase()} resume, JobBuddy resume builder, resume templates, industry-specific resumes, AI resume optimization`, // Dynamic keywords based on the role
          },
        ],
      });
    }
  },
  { immediate: true } // Ensures this watch effect runs immediately on component mount
);

function getImageUrlForCoverLetter(path: any): string {
  if (!path) {
    console.error("Invalid path provided");
    return ""; // Return a default image path or an error image
  }
  return require(`../../public/media/coverLetterExamples/${path}`);
}

function loadresumeExample() {
  const role = route.params.role?.toLowerCase();
  resumeExample.value = resumeExamples.find((example) => example.key.toLowerCase() === role);
}

function getImageUrl(path: any): string {
  if (!path) {
    console.error("Invalid path provided");
    return ""; // Return a default image path or an error image
  }
  return require(`../../public/media/resumeExamples/${path}`);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(_toDisplayString(resumeExample.value?.Role), 1),
        _hoisted_4
      ]),
      _createElementVNode("h5", _hoisted_5, [
        _createTextVNode(" A "),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(resumeExample.value?.Role) + " Resume Example That Got A Candidate Hired ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, " This resume helped a real JobBuddy user secure their " + _toDisplayString(resumeExample.value?.Role.toLowerCase()) + " position. Shared with permission to assist you in your job search, names, dates and places have been changed to protect their privacy. ", 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: getImageUrl(resumeExample.value?.ExampleImgSrc),
          alt: `Cover letter example for ${resumeExample.value?.Role}`,
          class: "img-fluid d-block my-3 w-100 shadow",
          loading: "lazy"
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", null, _toDisplayString(resumeExample.value?.WhyItWorked) + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _createElementVNode("i", null, " Check out our list of the best ATS keywords for a " + _toDisplayString(resumeExample.value?.Role.toLocaleLowerCase()) + " resume below. ", 1)
            ])
          ]),
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _hoisted_29
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("h5", null, [
          _createTextVNode(" Top ATS Keywords for a " + _toDisplayString(resumeExample.value?.Role) + " Resume", 1),
          _hoisted_32
        ])
      ]),
      _createElementVNode("p", _hoisted_33, " Here's some of the keywords that recruiters and hiring managers look for when hiring for a " + _toDisplayString(resumeExample.value?.Role.toLocaleLowerCase()) + " role. Including these keywords in your resume can help you pass applicant tracking systems (ATS) and show you're a good fit for the role. ", 1),
      _createElementVNode("div", _hoisted_34, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resumeExample.value?.ATSKeywords, (keyword) => {
          return (_openBlock(), _createElementBlock("div", {
            key: keyword,
            class: "border border-success rounded m-2 col-5 col-sm-2"
          }, [
            _createElementVNode("span", _hoisted_35, _toDisplayString(keyword), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (getImageUrlForCoverLetter(resumeExample.value?.ExampleImgSrc))
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("h3", _hoisted_45, [
                _createElementVNode("b", null, "Discover the " + _toDisplayString(resumeExample.value?.Role) + " Cover Letter That Got Someone Hired", 1)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode(" Check out a "),
                _hoisted_46,
                _createTextVNode(" " + _toDisplayString(resumeExample.value?.Role.toLocaleLowerCase()) + " cover letter that successfully secured a job offer. ", 1)
              ]),
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("img", {
                loading: "lazy",
                class: "m-auto",
                style: {"max-height":"350px","max-width":"100%"},
                src: getImageUrlForCoverLetter(resumeExample.value.ExampleImgSrc)
              }, null, 8, _hoisted_55)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_router_link, {
                to: { name: 'CoverLetterDetail', params: _unref(route).params.role }
              }, {
                default: _withCtx(() => [
                  _hoisted_57
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_58,
      _hoisted_59,
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resumeExamples), (example) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: example.Role,
                to: {
                name: 'ResumeDetail',
                params: { role: example.Role.toLowerCase().replace(/ /g, '-') },
              },
                style: {"text-decoration":"none"},
                class: "col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      src: getImageUrl(example.ExampleImgSrc),
                      alt: `Cover letter example
                for ${example.Role}`,
                      class: "shadow m-1 example-card"
                    }, null, 8, _hoisted_64),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("h5", _hoisted_66, _toDisplayString(example.Role), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_67,
        _hoisted_68,
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: { name: 'ResumeExamples' } }, {
            default: _withCtx(() => [
              _hoisted_69
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})